import React from "react";

const NetlifyContactForm = ({ formName }) => (
  <form
    method="post"
    data-netlify="true"
    data-netlify-recaptcha="true"
    name={formName}
    className="d-none"
  >
    <input name="fullname" type="text" />
    <input name="email" type="email" />
    <input name="phone" type="tel" />
    <input name="about" />
    <input name="informationTopic" />
    <textarea name="message" />
    <button type="submit"></button>
  </form>
);

export default NetlifyContactForm;
